var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006553",
    points: "0,0 0,39.992 31.16,39.992 39.033,0  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M21.204,9.486c-1.315-1.113-3.352-1.678-6.054-1.678       c-1.25,0-2.563,0.139-3.903,0.41c-0.685,0.14-1.348,0.31-2.021,0.521l-1.005,5.187c0.762-0.406,1.485-0.714,2.151-0.92       c0.896-0.277,1.929-0.419,3.07-0.419c1.128,0,1.957,0.265,2.465,0.785c0.507,0.521,0.763,1.184,0.763,1.97       c0,1.152-0.504,2.247-1.501,3.254c-0.986,0.998-3.024,2.601-6.056,4.763l-3.15,2.241l-1.17,6.048h15.401l0.951-4.918h-9.279       l4.063-2.827c2.441-1.731,4.282-3.395,5.47-4.941c1.183-1.539,1.78-3.252,1.78-5.09C23.179,12.072,22.515,10.596,21.204,9.486z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#009A84",
    points: "40,0.007 38.427,0.007 30.555,40 40,40  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "30.921,16.289 25.063,18.27 24.056,23.475 28.537,21.699       25.003,39.702 30.694,39.702 35.304,16.289  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS21);
export default __webpack_public_path__ + "static/media/s21.3b62de78722576923828c203ffd522c6.svg";
export { ForwardRef as ReactComponent };